export const projects = {
  ab: 'autofleamarket-photo',
  review: 'autofleamarket-review',
};
